module.exports = __webpack_public_path__ + "img/SuccessChek.ed026896.png";